import { ROW_TYPES } from './row-type-schedule.model';

export class RowScheduleModel {
  tbId: number = null;
  accountName: string = null
  cyAmount: number = 0;
  pyAmount: number = 0;
  sortOrder: number = 0;
  type: ROW_TYPES = ROW_TYPES.GENERAL;
}
